import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import * as moment from 'moment';
import { IAlbum, Lightbox } from 'ngx-lightbox';
import { Subject } from 'rxjs';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Employee from 'src/app/model/product/employee';
import { CreateEditTaskModalComponent } from 'src/app/pages/immo-ip/task/create-edit-task/create-edit-task-modal.component';
import {
  ModalService,
  ObservableHandlerPair,
} from 'src/app/services/modal.service';
import { TourPreviewStateService } from '../../../service/tour-preview-state.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import {
  AssignImmoTaskResult,
  AssignImmoTaskToTourControllerRequestService,
} from '../../../service/assign-immo-task-to-tour-controller-request.service';
import {
  AssignSubProjectResult,
  AssignSubProjectToTourControllerRequestService,
} from '../../../service/assign-sub-project-to-tour-controller-request.service';
import { TourDateChangeService } from '../../../service/tour-date-change.service';
import { TourPlanningEventService } from '../../../service/tour-planning-event.service';
import {
  ItemPlannedEvent,
  LastSelectedPlanValues,
} from '../../helper/immo-map-helper';
import {
  ImmoMapImmoTask,
  ImmoMapItem,
  ImmoMapSubProject,
  isImmoMapImmoTask,
  isImmoMapSubProject,
} from '../../services/model/immo-map-sub-project';
import { ImmoMapPopupInfoHelper } from './helper/immo-map-popup-info-helper';

@Component({
  selector: 'immo-map-popup-info',
  templateUrl: './immo-map-popup-info.component.html',
  styleUrls: ['./immo-map-popup-info.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: DateHelper.DEFAULT_MOMENT_FORMATS,
    },
  ],
})
export class ImmoMapPopupInfoComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnChanges
{
  @Input()
  index: number;
  @Input()
  item: ImmoMapItem;
  @Input()
  placerOptions: Employee[];
  @Input()
  toggleDisplay: Subject<number>;
  @Input()
  alwaysDisplay: boolean = false;

  @Output()
  backPressed = new EventEmitter<any>();
  @Output()
  placerUpdated = new EventEmitter<any>();
  @Output()
  itemPlanned = new EventEmitter<ItemPlannedEvent>();

  subProjectItem: ImmoMapSubProject;
  immoTaskItem: ImmoMapImmoTask;

  private static readonly SHOW_CLASS: string = '';
  private static readonly HIDE_CLASS: string = 'hidden';

  submitting: boolean = false;

  displayClass: string = ImmoMapPopupInfoComponent.HIDE_CLASS;

  involvedCompanies: string[];

  selectedPlacer: Employee;
  selectedTourDate: moment.Moment;
  locked: boolean = false;

  toggleDisplaySubscriptionAdded: boolean = false;

  today = new Date();

  constructor(
    private assignSubProjectToTourControllerRequestService: AssignSubProjectToTourControllerRequestService,
    private tourDateChangeService: TourDateChangeService,
    private tourPlanningEventService: TourPlanningEventService,
    private tourPreviewStateService: TourPreviewStateService,
    private _lightbox: Lightbox,
    private modalService: ModalService,
    private assignImmoTaskToTourControllerRequestService: AssignImmoTaskToTourControllerRequestService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeSpecializedItem();

    if (this.alwaysDisplay) {
      this.displayClass = ImmoMapPopupInfoComponent.SHOW_CLASS;
    } else if (this.toggleDisplay != null) {
      this.addSubscription(this.toggleDisplay, (i) => {
        this.displayClass =
          i === this.index
            ? ImmoMapPopupInfoComponent.SHOW_CLASS
            : ImmoMapPopupInfoComponent.HIDE_CLASS;
      });
      this.toggleDisplaySubscriptionAdded = true;
    }
    ImmoMapPopupInfoHelper.setFirstAssetStyle(this.item);
    ImmoMapPopupInfoHelper.setTypeDisplays(this.item);
    if (
      this.item.hasOwnProperty('project') &&
      (this.item as ImmoMapSubProject).project != null
    ) {
      this.involvedCompanies = ImmoMapPopupInfoHelper.getInvolvedCompanies(
        (this.item as ImmoMapSubProject).project
      );
      ImmoMapPopupInfoHelper.preprocessProducts(
        (this.item as ImmoMapSubProject).project.products
      );
    }
    this.fillPlacerForPlannedItem();
    this.addSubscription(
      this.tourDateChangeService.getTourDateSubject(),
      (date: moment.Moment) => {
        this.selectedTourDate =
          this.item.currentRequestDate != null
            ? moment(this.item.currentRequestDate)
            : date;
      }
    );
  }

  private initializeSpecializedItem(): void {
    if (this.item == null) {
      return;
    }
    if (isImmoMapSubProject(this.item)) {
      this.subProjectItem = this.item;
    } else if (isImmoMapImmoTask(this.item)) {
      this.immoTaskItem = this.item;
    }
  }

  private fillPlacerForPlannedItem(): void {
    if (this.item.placerId != null) {
      const matchingEmployee = this.placerOptions.find(
        (e) => e.id == this.item.placerId
      );
      if (matchingEmployee != null) {
        this.selectedPlacer = matchingEmployee;
      }
    }
  }
  updateTempPlacer(): void {
    this.placerUpdated.emit({
      subProjectId: null,
      immoTaskId: null,
      lastSelectedPlanValues: {
        selectedPlacer: this.selectedPlacer,
      },
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alwaysDisplay) {
      this.displayClass = changes.alwaysDisplay.currentValue
        ? ImmoMapPopupInfoComponent.SHOW_CLASS
        : ImmoMapPopupInfoComponent.HIDE_CLASS;
      if (
        changes.alwaysDisplay.currentValue === false &&
        !this.toggleDisplaySubscriptionAdded
      ) {
        this.addSubscription(this.toggleDisplay, (i) => {
          this.displayClass =
            i === this.index
              ? ImmoMapPopupInfoComponent.SHOW_CLASS
              : ImmoMapPopupInfoComponent.HIDE_CLASS;
        });
        this.toggleDisplaySubscriptionAdded = true;
      }
    }
  }

  hide(): void {
    this.doHide();
    this.backPressed.emit();
  }

  doHide(): void {
    this.displayClass = ImmoMapPopupInfoComponent.HIDE_CLASS;
  }

  doPlanItem(): void {
    this.submitting = true;
    if (this.item.type != 'Task') {
      this.assignSubProjectToTourControllerRequestService
        .assignSubProjectToTour(
          this.item.id,
          this.selectedPlacer.id,
          this.selectedTourDate,
          this.locked,
          this.item.type
        )
        .then((result: AssignSubProjectResult) => {
          this.tourPlanningEventService
            .getTourChangedForPlacersSubject()
            .next(result.affectedTours);
          this.tourPlanningEventService
            .getSubProjectWasAssignedSubject()
            .next(this.item.id);
          this.itemPlanned.emit({
            subProjectId: this.item.id,
            immoTaskId: null,
            lastSelectedPlanValues: {
              selectedPlacer: this.selectedPlacer,
            },
          });
        })
        .finally(() => (this.submitting = false));
    } else {
      this.assignImmoTaskToTourControllerRequestService
        .assignImmoTaskToTour(
          this.item.id,
          this.selectedPlacer.id,
          this.selectedTourDate,
          this.locked
        )
        .then((result: AssignImmoTaskResult) => {
          this.tourPlanningEventService
            .getTourChangedForPlacersSubject()
            .next(result.affectedTours);
          this.itemPlanned.emit({
            subProjectId: null,
            immoTaskId: this.item.id,
            lastSelectedPlanValues: {
              selectedPlacer: this.selectedPlacer,
            },
          });
        });
    }
  }

  fillPlanValues(lastSelectedPlanValues: LastSelectedPlanValues): void {
    if (this.item.placerId == null) {
      // Check for last activated preview installer if no manual selection was made
      if (!lastSelectedPlanValues.selectedPlacer) {
        const lastActivatedPreviewInstaller =
          this.tourPreviewStateService.getLastActivatedPreviewInstaller();
        if (lastActivatedPreviewInstaller) {
          this.selectedPlacer = lastActivatedPreviewInstaller;
          return;
        }
      }
      this.selectedPlacer = lastSelectedPlanValues.selectedPlacer;
    }
  }

  openLightbox(): void {
    if (CollectionHelper.isPopulated(this.item.assets)) {
      const album: IAlbum[] = this.item.assets.map((a) => {
        return {
          src: `/api/assets/${a.uuid}`,
          thumb: `/api/assets/${a.uuid}`,
          caption: '',
        };
      });
      this._lightbox.open(album, 0);
    }
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  openTaskEditModal(taskId: number): void {
    this.modalService.openComponentInModal(
      CreateEditTaskModalComponent,
      [
        {
          key: 'taskId',
          value: taskId,
        },
      ],
      new ObservableHandlerPair(
        (modalRef) => modalRef.componentInstance.result,
        (result) => {
          if (result === 'taskCreatedOrEdited' || result === 'taskArchived') {
            this.tourPlanningEventService
              .getSubProjectWasUnassignedSubject()
              .next();
          }
        }
      ),
      { minWidth: '97vw', height: '95vh' }
    );
  }
}
